import React, { useState } from 'react';
import { WStack, WTypography } from '../../wrappers/wrapper';
import styles from './article-row.module.scss';
import moment from 'moment';
import { TArticle, TComment, TUser } from '../../../models/common';
import { MoreHoriz, Favorite, FavoriteBorder, ChatBubbleOutline, Reply } from '@mui/icons-material';
import ViewProfile from '../../prefabs/view-profile-popover/view-profile-popover';
import ProfilePhoto from 'components/molecules/profile-photo/profile-photo';
import Button from 'components/atoms/button/button';
import ArticleMoreMenu from '../article-more-menu/article-more-menu';

interface ArticleRowProps {
  data: TArticle;
  anchorEl: HTMLElement | null;
  open: boolean;
  isLiked: boolean;
  totalLikeCount: number;
  totalCommentCount: number;
  lastComment: TComment | undefined;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleClose: () => void;
  navigateToArticle: (article_id: string) => void;
  onLikeClick?: () => void;
  deleteArticle: (article_id: string) => any;
  className?: string;
  hideInteractions?: boolean;
}

const ArticleRow: React.FC<ArticleRowProps> = ({
  data,
  anchorEl,
  open,
  isLiked,
  totalLikeCount,
  totalCommentCount,
  lastComment,
  handleClick,
  handleClose,
  navigateToArticle,
  onLikeClick,
  deleteArticle,
  className,
  hideInteractions,
}) => {
  const [profileUserId, setProfileUserId] = useState('');
  const [isProfileBoxVisible, setIsProfileBoxVisible] = useState(false);

  const classes = `${styles.rowContainer} ${className || ''}`.trim();
  return (
    <div className={classes}>
      <div className={styles.top}>
        <WTypography className={styles.title} onClick={() => navigateToArticle(data._id!)}>
          {data.title}
        </WTypography>
        {!hideInteractions && (
          <Button type="base" onClick={handleClick} className={styles.moreButton}>
            <MoreHoriz style={{color:"var(--color-white)"}} fontSize="small" />
          </Button>
        )}
      </div>
      {!hideInteractions && (
        <ProfilePhoto
          onClick={() => {
            setProfileUserId((data.publisher as TUser)._id!);
            setIsProfileBoxVisible(true);
          }}
          user={data.publisher}
          className={styles.publisher}
        />
      )}
      <div className={styles.dataContainer} onClick={() => navigateToArticle(data._id!)}>
        <WTypography className={styles.title}>{data.title}</WTypography>
        {!hideInteractions && (
          <WStack direction="row" alignItems="center">
            {lastComment ? (
              <>
                <Reply className={styles.reply} fontSize="small" />
                <WTypography
                  className={styles.subTitle}
                >{`${(lastComment.owner as TUser)?.username} replied ${moment(lastComment.created_at).fromNow()}`}</WTypography>
              </>
            ) : (
              <WTypography
                className={styles.subTitle}
              >{`${(data.publisher as TUser)?.username} posted ${moment(data.created_at).fromNow()}`}</WTypography>
            )}
          </WStack>
        )}
      </div>
      {!hideInteractions && (
        <div className={styles.actions}>
          <div>
            <div onClick={onLikeClick}>
              {isLiked ? <Favorite fontSize="small" /> : <FavoriteBorder fontSize="small" />}
              <span>{totalLikeCount || 0}</span>
            </div>
          </div>
          <div>
            <div onClick={() => navigateToArticle(data._id!)}>
              <ChatBubbleOutline fontSize="small" />
              <span>{totalCommentCount}</span>
            </div>
          </div>
          <Button type="base" onClick={handleClick} className={styles.moreButton}>
            <MoreHoriz style={{color:"var(--color-white)"}} fontSize="small" />
          </Button>
        </div>
      )}
      <ArticleMoreMenu
        article={data}
        open={open}
        anchorEl={anchorEl}
        deleteArticle={deleteArticle}
        handleClose={handleClose}
      />
      {isProfileBoxVisible && !hideInteractions && (
        <ViewProfile
          showEditButton={false}
          user_id={profileUserId}
          onClose={() => setIsProfileBoxVisible(false)}
        />
      )}
    </div>
  );
};

export default ArticleRow;
